import { createContext } from 'react';

export interface RealtimerProviderContextValue {
  subscribe: (audience: string, callback: (message: any) => any) => any;
  unsubscribe: (audience: string, callback: (message: any) => any) => any;
  isConnected: boolean;
}

export const RealtimerProviderContext = createContext<RealtimerProviderContextValue>({
  subscribe: () => null,
  unsubscribe: () => null,
  isConnected: false,
});
